const sagePostalValidator = (sageName: string | null) => {
  sageName = sageName?.trim() ?? "";
  if (sageName.length === 0) {
    return "error.not_empty";
  }
  if (sageName.length > 9) {
    return "error.sageName.maxLength9";
  }
  return "";
};
export default sagePostalValidator;
